
import TableList from "@components/templates/tablelist";
import { HttpBillImportList } from "@/service/fedex";
import { mapGetters } from "vuex";
import comImport from './comImport'
// import mixin from "../mixin";
export default {
    mixins: [TableList],
    components: {
        comImport
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpBillImportList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "query":
                    var url = this.$router.resolve({
                        name: "fedexUpdateBillimport",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.inbound_import_data',{defaultValue:'导入数据'}),
                        width: 460,
                        showFooter: false,
                        component: "comImport",
                    }
                    break
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return [{
                label: this.$t('fbb.alloment.query_detail',{defaultValue:'查看详情'}),
                show: true,
                params: id,
                operate: 'query'
            }]
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getCarrierServiceList', 'getCarrierServiceAllList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.import',{defaultValue:'导入'}),
                    operate: "import",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "Tracking NO",
                    tag: 'vInput',
                    key: 'EQ_trackingNo',
                    show: true,
                },
                {
                    label: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                    tag: 'vInput',
                    key: 'EQ_invoiceNo',
                    show: true,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.fedex.import_date',{defaultValue:'导入日期'}),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    default: this.handleDateRange().join(' ~ '),
                    show: true,
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    // label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    label: this.$t("fbb.bill.logistics_products", {
                        defaultValue: "物流产品",
                    }),
                    tag: 'vSelect',
                    key: 'EQ_carrierCode',
                    more: true,
                    options: [
                        {value:'FedEx',label:'FedEx'},
                        {value:'UPS',label:'UPS'},
                    ],
                    props: {
                        filterable: true,
                        clearable: true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    // label: "承运商服务",
                    tag: 'Select',
                    key: 'EQ_carrierServiceCode',
                    more: true,
                    options: this.getCarrierServiceAllList.map(item=>{
                        return {
                            value: item.attach.carrierServiceCode,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                        clearable: true,
                    }
                },
                {
                    label: this.$t('fbb.alloment.taskNo',{defaultValue:'任务编号'}),
                    tag: 'vInput',
                    key: 'EQ_taskNo',
                    more: true,
                },
                {
                    label: this.$t('fbb.fedex.cutofftime',{defaultValue:'结算时间'}),
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_invoiceDate',
                    more: true,
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },

            ]
        },
        columns() {
            return [{
                title: this.$t('global.common.actions',{defaultValue:'操作'}),
                maxWidth: 90,
                render: this.getOperateNodes
            },
            // {
            //     title: this.$t('fbb.fedex.soucessystem',{defaultValue:'来源系统'}),
            //     // key: 'sourceSystem',
            //     render:(h,{row})=>{
            //         switch(row.sourceSystem){
            //             case 'fbb': return this.$t('global.common.fbb',{defaultValue:'云仓'}); break;
            //             default: return 'Bizark Cloud Shipping'; break;
            //         }
            //     }
            // },
            {
                title: this.$t('fbb.alloment.taskNo',{defaultValue:'任务编号'}),
                key: 'taskNo',
            },
            {
                title: 'Tracking NO',
                key: 'trackingNo',
            },
            {
                // title: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                title: this.$t("fbb.bill.logistics_products", {
                    defaultValue: "物流产品",
                }),
                key: 'carrierCode',
            },
            {
                title: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                // title: '承运商服务',
                key: 'carrierServiceCode',
                render: (h, {row})=>{
                    return <div>{row.carrierServiceCode || '--'}</div>
                }
            },
            {
                title: this.$t('fbb.fedex.zonecode',{defaultValue:'分区'}),
                key: 'zoneCode',
            },
            {
                title: this.$t('fbb.fedex.account',{defaultValue:'结算账户'}),
                key: 'account',
            },
            {
                title: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
                key: 'invoiceNo',
            },

            {
                title: this.$t('fbb.fedex.discountCost',{defaultValue:'账单运费'})+'（usd）',
                key: 'discountCost',
            },
            {
                title: this.$t('fbb.expresspackage.package_length',{defaultValue:'包裹长'})+'（inch）',
                key: 'packageLength',
            },
            {
                title: this.$t('fbb.expresspackage.package_width',{defaultValue:'包裹宽'})+'（inch）',
                key: 'packageWidth',
            },
            {
                title: this.$t('fbb.expresspackage.package_height',{defaultValue:'包裹高'})+'（inch）',
                key: 'packageHeight',
            },
            {
                title: this.$t('fbb.expresspackage.package_weight',{defaultValue:'包裹重量'})+'（lbs）',
                key: 'packageWeight',
            },
            {
                title: this.$t('fbb.fedex.cutofftime',{defaultValue:'结算时间'}),
                key: 'invoiceDate',
            },
            {
                title: this.$t('fbb.fedex.import_time',{defaultValue:'导入时间'}),
                key: 'createdAt',
            },
            ];
        },

    },

};
